import React, { useContext } from 'react';
import format from 'string-template';
import { compose } from 'recompose';
import { observer } from 'mobx-react';

import MealPlanAssignmentContext from '../../../../../../../context/MealPlanAssignmentContext';

import { SelectorContainer, ProductSelect } from './styles';
import texts from './texts.json';

const ProductSelector = () => {
  const {
    heldProducts = [],
    mealPlanAssignmentDocs = [],
    selectedProductId,
    setSelectedProductId,
  } = useContext(MealPlanAssignmentContext);

  // Held products, not existing plans: the product most needing a choice is the one with none.
  if (heldProducts.length < 2) {
    return null;
  }

  const productIdsWithAPlan = new Set(mealPlanAssignmentDocs.map((assignment) => assignment.productId));

  const options = heldProducts.map(({ productId, productName }) => {
    const name = productName || texts.unnamedProduct;
    return {
      value: productId,
      label: productIdsWithAPlan.has(productId)
        ? name
        : format(texts.productWithoutAPlan, { productName: name }),
    };
  });

  return (
    <SelectorContainer>
      <ProductSelect
        value={selectedProductId}
        options={options}
        onChange={(event) => setSelectedProductId(event.target.value)}
      />
    </SelectorContainer>
  );
};

export default compose(observer)(ProductSelector);
